import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { mismatchedDataDetailsApi } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'
import MockLoadingBlock from '../../../../mock/MockLoadingBlock'
import MismatchedDataDetailsInner from './MismatchedDataDetailsInner'
import { socket } from '../../../../../socket'

export default function MismatchedDataDetails({data}) {
    const dispatch = useDispatch()

    const {patientId} = useParams()

    const [loading, setLoading] = useState(false)
    const [caseFound, setCaseFound] = useState(null)


    // let caseFound = data.find(item => item.case?.id == patientId)
    
    const userToken = useSelector(state => state.user.token)
    const caseId = caseFound?.case?.id

    useEffect(() => {       
        const getCase = async () => {
            if (userToken && patientId && patientId !== 'undefined' && patientId !== 'null') {
                setLoading(true)
                try {
                    const caseDetail = await mismatchedDataDetailsApi(userToken, patientId)
                    
                    if (caseDetail?.status) {
                        dispatch(notificationActions.setError(caseDetail))
                    } else {
                        dispatch(caseActions.setActiveCase(caseDetail)) 
                        dispatch(caseActions.pushLastActiveCases({
                            id: caseDetail.case.id,
                            // name: `${caseDetail.patient.first_name} ${caseDetail.patient.last_name}`,
                            name: caseDetail.patient.name,
                            // workQSlug: 'drivers-license-mismatch'
                            person_number: caseDetail.patient.person_number
                        }))

                        setCaseFound(caseDetail)
                    }
                } finally {
                    setLoading(false)
                }
            }
        }

        getCase()
    }, [patientId, userToken, dispatch])

    useEffect(() => {
        if (!caseId) {
            return
        }

        const eventName = `case-updated-${caseId}`
        const caseUpdatedHandler = (payload) => {
            const incomingData = payload?.data ?? payload?.row ?? payload
            if (!incomingData || typeof incomingData !== 'object') {
                return
            }

            setCaseFound((prevCase) => {
                if (!prevCase) {
                    return prevCase
                }

                const updatedCase = {
                    ...prevCase,
                    case: {
                        ...prevCase.case,
                        ...(incomingData.case || {}),
                    },
                    patient: {
                        ...prevCase.patient,
                        ...(incomingData.patient || {}),
                    },
                }

                dispatch(caseActions.setActiveCase(updatedCase))
                return updatedCase
            })
        }

        if (!socket.connected) {
            socket.connect()
        }

        socket.on(eventName, caseUpdatedHandler)

        return () => {
            socket.off(eventName, caseUpdatedHandler)
        }
    }, [caseId, dispatch])

    return <>
        {loading && <MockLoadingBlock height={700} width={'100%'} noMargin={true}/>}
        {!loading && caseFound && <MismatchedDataDetailsInner data={caseFound}/>}
        {/* {!loading && caseFound && <PoliceReportDetailsInner data={caseFound}/>} */}
    </>
}